import CustomerEmailCapturedEvent from '../../events/customer-email-captured-event';
import { focusFirstInput } from '../shared/modal-autofocus';

// Se piden al abrir su paso: pintarlos en cada página abriría una sesión por su token CSRF.
const FORM_URLS = {
    login: '/club-member-acquisition/login-form',
    register: '/club-member-acquisition/register-form',
    join: '/club-member-acquisition/join-club-form',
};

// Sin conexión, fetch lanza una excepción. Response.error() la convierte en una respuesta fallida más.
const request = (url, options) => fetch(url, options).catch(() => Response.error());

document.addEventListener('alpine:init', () => {
    window.Alpine.data('ClubMemberAcquisition', (firstStep) => ({
        step: firstStep,
        forms: { login: '', register: '', join: '' },
        nif: '',
        customerType: null,
        sending: false,
        nifError: false,
        loginError: false,
        failed: false,

        init() {
            this.$el.addEventListener('show.bs.modal', () => this.show(firstStep));

            // Tras el alta se recarga la página para que salgan los precios de socio.
            this.$el.addEventListener('hide.bs.modal', (event) => {
                if (this.step === 'success') {
                    event.preventDefault();
                    window.location.reload();
                }
            });
        },

        async show(step) {
            const container = this.$refs[step];
            this.step = step;
            this.failed = false;
            this.nifError = false;
            this.loginError = false;

            if (FORM_URLS[step] && this.forms[step] === '') {
                const response = await request(FORM_URLS[step]);

                if (!response.ok) {
                    this.failed = true;
                    return;
                }

                this.forms[step] = await response.text();
            }

            this.focusStep(container);
        },

        // x-show enseña el paso en el siguiente frame, y hasta entonces su campo no acepta el foco.
        focusStep(container) {
            this.$nextTick(() => requestAnimationFrame(() => focusFirstInput(container)));
        },

        async checkNif(form) {
            // El botón en carga no acepta clics, pero Enter en un campo vuelve a enviar el formulario.
            if (this.sending) {
                return;
            }

            this.nifError = false;
            const response = await this.post(form);

            if (response.ok) {
                const { nif, customerType, step } = await response.json();
                document.dispatchEvent(new CustomEvent('Club_Member_Acquisition_Lead'));
                this.nif = nif;
                this.customerType = customerType;
                this.show(step);
            } else if (response.status === 400) {
                document.dispatchEvent(new CustomEvent('Club_Member_Acquisition_Lead_Error'));
                this.nifError = true;
            } else {
                this.failed = true;
            }
        },

        async logIn(form) {
            if (this.sending) {
                return;
            }

            this.loginError = false;
            // Con esta cabecera Sylius responde 401 en vez de redirigir a la página de login.
            const response = await this.post(form, { 'X-Requested-With': 'XMLHttpRequest' });

            if (response.ok) {
                window.location.reload();
            } else if (response.status === 401) {
                this.loginError = true;
            } else {
                this.failed = true;
            }
        },

        register(form) {
            if (this.sending) {
                return;
            }

            const email = form.elements['sylius_customer_registration[email]'].value.trim();

            if (email !== '') {
                document.dispatchEvent(new CustomerEmailCapturedEvent(email));
            }

            return this.signUp(form);
        },

        // Registro de un invitado y alta de un cliente con sesión.
        async signUp(form) {
            if (this.sending) {
                return;
            }

            // Mientras se envía la clienta puede ir a otro paso; los errores son del de este formulario.
            const step = this.step;
            // $refs se busca desde este formulario, que deja de estar en la página al repintarlo.
            const container = this.$refs[step];
            const response = await this.post(form);

            // Si va bien, Sylius redirige a la página de origen y fetch sigue la redirección.
            if (response.ok) {
                window.dataLayerPushDeferred({ event: 'sign_up', event_type: 'dni-socio' });
                this.step = 'success';
            } else if (response.status === 422) {
                if (step === 'register') {
                    document.dispatchEvent(new CustomEvent('Club_Member_Acquisition_Register_Error'));
                }

                this.forms[step] = await response.text();
                this.focusStep(container);
            } else {
                this.failed = true;
            }
        },

        async post(form, headers = {}) {
            this.sending = true;
            this.failed = false;

            const response = await request(form.action, { method: 'POST', body: new FormData(form), headers });
            this.sending = false;

            return response;
        },
    }));
});
